<template>
    <div class="myAchievement">
        <div class="achievementList">
            <div class="item" v-for="(item, index) in list" :key="index">
                <img :src="item.certfileurl" alt="">
                <p class="time">{{item.certtime}}获得</p>
            </div>
        </div>
        <Page v-if="list.length" @currentChange="pageChange" :page="page" />
        <div class="noData" v-if="!list.length">
            <img :src="require('@/common/images/gujing/null.png')" alt="">
            <p>当前暂无成就</p>
        </div>
    </div>
</template>
<script>
import Page from '../../components/page2'
import {getMyCertInfo} from 'api/personalCenterApi'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            list: [],
            total: 10,
            page: {
                page: 1,
                pageSize: 8,
                total: 0
            }
        }
    },
    created() {
        this.getMyCertInfo()
    },
    methods: {
        pageChange() {
            this.getMyCertInfo()
        },
        getMyCertInfo() {
            this.setLoading(true)
            getMyCertInfo({
                data: this.page,
                success: res => {
                    this.setLoading(false)
                    this.list = res.data.content
                    this.page.total = res.data.pageinfo.rowCount
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang="scss">
    .myAchievement {
        padding: 20px 25px 30px;
        background: #fff;
        .achievementList {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .item {
                width: 198px;
                margin-bottom: 20px;
                text-align: center;
                &:not(:nth-of-type(4)) {
                    margin-right: 40px;
                }
                img {
                    width: 198px;
                    height: 352px;
                    margin-bottom: 12px;
                }
                .time {
                    text-align: center;
                    font-size: 14px;
                    color: #6E7B8E;
                }
            }
        }
        .noData {
            padding: 88px 0 122px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
                margin-bottom: 20px;
                // width: 200px;
                height: 96px;
            }
            p {
                font-size: 14px;
                color: #CADAEE;
            }
        }
    }
</style>